import xhr from 'Common/utils/xhr'
import { foldersEndpoint } from './endpoints'

/**
 * Triggers the creation of a folder notification
 * @param {number} id - The ID of the folder to create the notification
 */
const sendFolderNotification = id =>
  xhr({
    url: `${foldersEndpoint}/${id}/send_notification`,
    method: 'POST',
  })

export default sendFolderNotification
